var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{staticStyle:{"background-color":"transparent"},attrs:{"id":"modal-loading","hide-header":"","hide-footer":"","centered":"","no-close-on-backdrop":true,"content-class":"modal-transparent-background text-center","bodyTextVariant":"primary"}},[_c('b-spinner',{attrs:{"label":"Loading..."}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }